export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-page">
      <section className="container-px pt-16 md:pt-24 pb-16">
        <div className="max-w-3xl">
          <div className="overline mb-6">Legal</div>
          <h1 className="font-heading text-5xl md:text-6xl font-light tracking-tight text-ink leading-[1.05]">
            Disclaimer
          </h1>
          <p className="mt-6 text-lg text-ink-soft leading-relaxed">
            Last Updated: July 11, 2026. The information provided on ospfudr.com is for general informational and community networking purposes only.
          </p>
        </div>
      </section>

      <section className="container-px pb-24">
        <div className="max-w-3xl card-premium space-y-8">
          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">1. No Professional Advice</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              All information on this site is provided in good faith. However, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">2. Directory Profile Disclaimer</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              The professional directory listings and profiles displayed on this website are submitted self-actively by the individual forum members. Oswal Sabha Professional Forum does not verify, validate, endorse, or guarantee the qualifications, credentials, quality of services, or claims made by any member listed in the directory.
              <br /><br />
              Any engagement, transaction, or agreement between you and any professional listed in the directory is solely at your own risk. We recommend that users perform their own independent due diligence before hiring or engaging the services of any professional.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">3. External Links Disclaimer</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              Our website may contain (or you may be sent through the site to) links to other websites or content belonging to or originating from third parties. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third-party websites linked through our site.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">4. AdSense and Third-Party Advertisements</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              This website may display third-party advertisements served by Google AdSense. The display of such advertisements does not constitute an endorsement, recommendation, or representation by us of the products or services advertised. We are not responsible for the content, quality, or policies of third-party ads or the advertisers serving them.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
